import { FC } from "react";
import styled from "styled-components";
import ServiceUnavailable from "../ServiceUnavailable/ServiceUnavailable";
import { useServiceUnavailable } from "../../hooks/useServiceUnavailable";

interface ErrorBoundaryFallBackProps {
  error?: any;
}

const StyledErrorBoundaryFallBack = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const StyledErrorMessageText = styled.p`
  font-size: 24px;
  color: #000000;
  margin-bottom: 26px;
  line-height: 27px;
`;

const StyledErrorMessage = styled.a`
  font-size: 24px;
  color: #000000;
  margin-bottom: 26px;
  line-height: 27px;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

const ErrorBoundaryFallBack: FC<ErrorBoundaryFallBackProps> = ({ error }): JSX.Element => {
  const isServiceUnavailable = useServiceUnavailable();

  if (isServiceUnavailable) {
    return <ServiceUnavailable />;
  }

  return (
    <StyledErrorBoundaryFallBack>
      <StyledErrorMessageText>Something went wrong</StyledErrorMessageText>
      <StyledErrorMessage href={`${window.location.origin}/bond-list`}>Reload the page and try again</StyledErrorMessage>
    </StyledErrorBoundaryFallBack>
  )
}

export default ErrorBoundaryFallBack;